module.exports = __webpack_public_path__ + "static/media/22ESCWA1.0298345c.jpg";